import React, { createContext, useContext } from 'react';

type SelectAdvancedWithGroupingContent = {
  selectedGroupOptions: number[];
  filteredSelectedItems: any[];
  filteredNonSelectedItems: any[];
  addItemsToSelectedGroupOptions: (nums: number[]) => void;
  removeItemsFromSelectedGroupOptions: (nums: number[]) => void;
  handleSelectItem: (selectedItem: any) => void;
  handleDeselectItem: (selectedItem: any) => void;
  handleSelectAll: () => void;
  handleSelectNone: () => void;
  handleSearch: (e: any) => void;
  handleApplySelection: () => void;
};

export const SelectAdvancedWithGroupingContext = createContext<SelectAdvancedWithGroupingContent>({
  selectedGroupOptions: [],
  filteredSelectedItems: [],
  filteredNonSelectedItems: [],
  addItemsToSelectedGroupOptions: () => {
    // empty
  },
  removeItemsFromSelectedGroupOptions: () => {
    // empty
  },
  handleSelectItem: () => {
    // empty
  },
  handleDeselectItem: () => {
    // empty
  },
  handleSelectAll: () => {
    // empty
  },
  handleSelectNone: () => {
    // empty
  },
  handleSearch: () => {
    // empty
  },
  handleApplySelection: () => {
    // empty
  },
});

export const useSelectAdvancedWithGroupingContext = () => useContext(SelectAdvancedWithGroupingContext);
